import api from "./api";

export const getAllEntreprises = async () => {
  try {
    const response = await api.get(`/master/entreprise/all`);
    return response.data;
  } catch (error) {
    console.error("There was an error fetching the data:", error);
    throw error;
  }
}

export const showEntreprise = async (id) => {
  try {
    const response = await api.get(`/master/entreprise/show-byId/${id}`);
    return response.data;
  } catch (error) {
    console.error("There was an error fetching the data:", error);
    throw error;
  }
}

export const addEntreprise = async (data) => {
  try {
    const response = await api.post('/master/entreprise/create', data, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  } catch (error) {
    console.error("There was an error fetching the data:", error);
    throw error;
  }
}

export const editEntreprise = async (data, id) => {
  try {
    const response = await api.post(`/master/entreprise/update/${id}`, data, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  } catch (error) {
    console.error("There was an error fetching the data:", error);
    throw error;
  }
}

export const deleteEntreprise = async (data) => {
  try {
    const response = await api.post(`/master/entreprise/delete`, data);
    return response.data;
  } catch (error) {
    console.error("There was an error fetching the data:", error);
    throw error;
  }
}

export const getDashboardStats = async () => {
  try {
    const response = await api.get('/master/dashboard/stats');
    return response.data;
  } catch (error) {
    console.error("There was an error fetching dashboard stats:", error);
    throw error;
  }
}

// Back-office home: per-client list of open subjects (technique / coûts / commercial).
export const getOverview = async () => {
  try {
    const response = await api.get('/master/dashboard/overview');
    return response.data;
  } catch (error) {
    console.error("There was an error fetching the overview:", error);
    throw error;
  }
}

export const downloadFile = async (filePath) => {
  try {
    const response = await api.post('/public/download', {filePath: filePath,}, {
      responseType: 'blob',
    });

    const fileURL = window.URL.createObjectURL(new Blob([response.data]));
    return fileURL;
  } catch (error) {
    console.error("There was an error fetching the data:", error);
    throw error;
  }
}
